import { C as CosmosSpinner$1, d as defineCustomElement$1 } from './p-HrLUFnJX.js';

const CosmosSpinner = CosmosSpinner$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosSpinner, defineCustomElement };
